import './App.js';
import * as modules from './modules';
//import './modules/index.js';
import {
    multipleBannerSwiper,
    multipleReBannerSwiper,
    reSlider,
    reSliderPopular,
    reSliderMobile,
    reSliderCardio,
    reSliderCardioTagSwapper,
    reSliderStories,
    sliderNews,
    sliderReNews,
    sliderProducts,
    dataContactsBlockTabsSwiper,
    sliderSteps,
    sliderStepsThumb
} from './swiper-configs';
import {detectBlockOnScreen} from './utils/animation-triger'
import { addEventNewsBtn } from './modules/Util.js'

import Dropzone from "dropzone";
import Validate from './modules/Validate.js';

Dropzone.autoDiscover = false;


const selectorSlider = {
    bannerMultiple: `.slider-banner--multiple`,
    reBannerMultiple: `.re-slider-banner--multiple`,
    bannerSingle: `.slider-banner--single`,
    news: `.slider-news`,
    reNews: `.re-slider-news`,
    products: `.slider-products`,
    reSlider: `.re-slider`,
    reSliderCardio: `.re-slider-cardio`,
    reSliderStories: `.re-slider-stories`,
    reSliderMobile: `.re-slider-mobile`,
    reSliderPopular: `.re-slider-popular`,
    sliderSteps: `.js-swiper-steps`,
    sliderStepsThumb: `.js-swiper-steps-thumb`
};

/*new contact*/
let companyHistorySwiperOne = null;
let countContactsBlock = 0
/*
    TODO - по возможности переделать, сейчас плохо
    Нужно расчитывать не на тики  setInterval,
    а инициализировать слайдеры хотя бы в колбэке loadLibrary(LIB_URL.SWIPER, () => {})
 */
let intervalContactsBlock = setInterval(() => {
    countContactsBlock = countContactsBlock + 100
    if (countContactsBlock === 10000) {
        clearInterval(intervalContactsBlock)
    }
    if (window.Swiper) {
        if($('[data-cardio-tuesday-webinars-slider]').length > 0){
            new Swiper($('[data-cardio-tuesday-webinars-slider]')[0], {
                slidesPerView: 3,
                spaceBetween: 30,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    580: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    960: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1270: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                },
                scrollbar: {
                    el: $('[data-cardio-tuesday-webinars-scrollbar]')[0],
                    draggable: true,
                    snapOnRelease: true,
                    dragSize: 'auto',
                },
                navigation: {
                    nextEl: $('[data-cardio-tuesday-webinars-next]')[0],
                    prevEl: $('[data-cardio-tuesday-webinars-prev]')[0],
                },
                pagination: {
                    el: $('[data-cardio-tuesday-webinars-pagination]')[0],
                    type: 'bullets',
                    bulletClass: `re-slider-cardio__pagination-item`,
                    bulletActiveClass: `re-slider-cardio__pagination-item--active`,
                    clickable: true
                },
                on: {
                    init: (swiper) => {
                        let arr = []
                        swiper.slides.forEach(item => {
                            arr.push($(item).height())
                        })
                        swiper.slides.forEach(item => {
                            $(item).css('minHeight', `${Math.max(...arr)}px`)
                        })
                    }
                }
            })
        }
        if($('[data-cardio-tuesday-product-slider]').length > 0){
            new Swiper($('[data-cardio-tuesday-product-slider]')[0], {
                slidesPerView: 4,
                spaceBetween: 0,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    580: {
                        slidesPerView: 2,
                        spaceBetween: 0
                    },
                    960: {
                        slidesPerView: 2,
                        spaceBetween: 0
                    },
                    1270: {
                        slidesPerView: 4,
                        spaceBetween: 0
                    },
                },
                scrollbar: {
                    el: $('[data-cardio-tuesday-product-scrollbar]')[0],
                    draggable: true,
                    snapOnRelease: true,
                    dragSize: 'auto',
                },
                navigation: {
                    nextEl: $('[data-cardio-tuesday-product-next]')[0],
                    prevEl: $('[data-cardio-tuesday-product-prev]')[0],
                },
                pagination: {
                    el: $('[data-cardio-tuesday-product-pagination]')[0],
                    type: 'bullets',
                    bulletClass: `re-slider-cardio__pagination-item`,
                    bulletActiveClass: `re-slider-cardio__pagination-item--active`,
                    clickable: true
                },
                on: {
                    init: (swiper) => {
                        let arr = []
                        swiper.slides.forEach(item => {
                            arr.push($(item).height())
                        })
                        swiper.slides.forEach(item => {
                            $(item).css('minHeight', `${Math.max(...arr)}px`)
                        })
                    }
                }
            })
        }

        if ($('[data-quality-page-swiper]').length > 0) {
            new Swiper($('[data-quality-page-swiper]')[0], {
                slidesPerView: 1,
                spaceBetween: 0,
                effect: 'fade',
                speed: 400,
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: $('[data-quality-page-swiper-next]')[0],
                    prevEl: $('[data-quality-page-swiper-prev]')[0],
                },
                pagination: {
                    el: $('[data-quality-page-swiper-pagination]')[0],
                    type: 'bullets',
                    clickable: true
                },
                on: {
                    init: (swiper) => {
                        swiper.slides.forEach(item => {
                            $(item).css('minHeight', `${$('[data-quality-page-swiper-img]').height()}px`)
                        })
                        setTimeout(() => {
                            if ($(window).width() < 768) {
                                const paginationW = $(swiper.pagination.el).width() / swiper.slides.length
                                swiper.pagination.bullets.forEach(el => {
                                    $(el).css('width', `${paginationW}px`)
                                })
                            }
                        }, 200)
                    },
                    resize: (swiper) => {
                        swiper.slides.forEach(item => {
                            $(item).css('minHeight', `${$('[data-quality-page-swiper-img]').height()}px`)
                        })
                        setTimeout(() => {
                            if ($(window).width() > 767) {
                                swiper.pagination.bullets.forEach(el => {
                                    $(el).css('width', 'auto')
                                })
                            }
                        }, 200)
                    },
                }
            })
        }

        if($('[data-partnership-slider]').length){
            new Swiper($('[data-partnership-slider]')[0], {
                slidesPerView: 2,
                spaceBetween: 20,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    767: {
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                    },
                    961: {
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                    },
                    1366:{
                        slidesPerView: 2,
                        spaceBetween: 20,
                    }

                },
                navigation: {
                    nextEl: $('[data-partnership-slider-next]')[0],
                    prevEl: $('[data-partnership-slider-prev]')[0],
                },
                pagination: {
                    el: $('[data-partnership-slider-pagination]')[0],
                    type: 'bullets',
                    clickable: true
                },
                on: {
                    init: function (swiper){
                        const arr = []
                        setTimeout(()=>{
                            swiper.slides.forEach(item => {
                                arr.push($(item).outerHeight(true))
                            })
                            swiper.slides.forEach(item => {
                                $(item).css('height', `${Math.max(...arr)}px`)
                            })
                        }, 100)
                    }
                }
            })
        }

        new Swiper($('[data-about-two-slider-new]')[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 20,
                },
                961: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }

            },
            navigation: {
                nextEl: $('[data-about-two-new-next]')[0],
                prevEl: $('[data-about-two-new-prev]')[0],
            },
            pagination: {
                el: $('[data-about-two-new-pagination]')[0],
                type: 'bullets',
                clickable: true
            },
        })



        new Swiper($('[data-about-two-slider]')[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                    allowTouchMove: true,
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 20,
                    allowTouchMove: true,

                },
                961: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    allowTouchMove: false,
                }
            },
            navigation: {
                nextEl: $('[data-about-two-next]')[0],
                prevEl: $('[data-about-two-prev]')[0],
            },
            pagination: {
                el: $('[data-about-two-pagination]')[0],
                type: 'bullets',
                clickable: true
            },
        })

        companyHistorySwiperOne = new Swiper($('[data-company-history-swiper]')[0], {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            speed: 400,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: $('[data-company-history-next]')[0],
                prevEl: $('[data-company-history-prev]')[0],
            },
            pagination: {
                el: $('[data-company-history-pagination]')[0],
                type: 'bullets',
                clickable: true
            },
            on: {
                resize: (swiper) => {
                    addText(swiper.activeIndex)
                },
                init: (swiper) => {
                    $('[data-company-history-row]').each(function (e) {
                        if (swiper.activeIndex !== e) {
                            $(this).addClass('up')
                        }
                    })
                    addText(0)
                    $($('[data-company-history-bottom-item]')[swiper.activeIndex]).addClass('active')
                    $('[data-company-history-bottom-item]').each(function (e) {
                        if (e === 0) {
                            slideChangeArr[e] = slideChangeCount;
                        } else {
                            slideChangeCount = slideChangeCount + $(this).width()
                            slideChangeArr[e] = slideChangeCount
                        }
                    })
                },
                slideChangeTransitionStart: (swiper) => {
                    const cloneEl = $($('[data-company-history-row]')[swiper.previousIndex]).clone().removeAttr("data-company-history-row").attr('data-company-history-double', '').removeClass('up').addClass('fixed')
                    $($('[data-company-history-row]')[swiper.activeIndex]).parent().append(cloneEl)
                    const count = $('[data-company-history-bottom-item]').length
                    addText(swiper.activeIndex)
                    setTimeout(() => {
                        $($('[data-select-custom-item]')[swiper.activeIndex]).trigger('click')
                        $('[data-company-history-row]').each(function (e) {
                            if (swiper.activeIndex === e) {
                                $('[data-company-history-bottom-item]').each(function (e) {
                                    $(this).removeClass('active')
                                    $(this).addClass('none')
                                    if (swiper.activeIndex === e) {
                                        $(this).addClass('active')
                                        $(this).removeClass('none')
                                    }
                                    if (swiper.activeIndex + 1 === e) {
                                        $(this).removeClass('none')
                                    }
                                })
                                $('[data-company-history-bottom]').css({
                                    'transform': `translate(-${slideChangeArr[swiper.activeIndex]}px)`,
                                    'transition': '0.3s linear'
                                })
                                $(this).removeClass('up')
                                setTimeout(() => {
                                    $('[data-company-history-double]').addClass('none')
                                }, 0)
                                setTimeout(() => {
                                    $('[data-company-history-bottom-first]').text($($('[data-company-history-bottom-item]')[swiper.activeIndex]).text())
                                    $('.company-history-block__bottom-text-item.active').addClass('none')
                                    $('[data-company-history-double]').remove()
                                }, 200)
                            } else {
                                $(this).addClass('up')
                            }
                        })
                        if ((count - 1) === swiper.activeIndex || (count - 2) === swiper.activeIndex) {
                            $('[data-company-history-bottom-end]').css({'opacity': '0'})
                        } else {
                            $('[data-company-history-bottom-end]').css({'opacity': '1'})
                        }
                    }, 170)
                },
            }
        })


        if ($('[data-about-cards-slider-swiper]').length > 0) {
            new Swiper($('[data-about-cards-slider-swiper]')[0], {
                slidesPerView: 2.30,
                spaceBetween: 84,
                breakpoints: {
                    0: {
                        slidesPerView: 1.1,
                        spaceBetween: 20
                    },
                    580: {
                        slidesPerView: 1.4,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 2.3,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 2.3,
                        spaceBetween: 50
                    },
                    1280: {
                        slidesPerView: 2.5,
                        spaceBetween: 50
                    },
                    1490: {
                        slidesPerView: 2.30,
                        spaceBetween: 84
                    }
                },
                navigation: {
                    nextEl: $('[data-about-cards-slider-next]')[0],
                    prevEl: $('[data-about-cards-slider-prev]')[0],
                },
                pagination: {
                    el: $('[data-about-cards-slider-pagination]')[0],
                    type: 'bullets',
                    clickable: true
                },
            })
        }

        if($(['data-re-news-block-swiper']).length > 0){
            addEventNewsBtn()
            new Swiper($('[data-re-news-block-swiper]')[0], {
                slidesPerView: 2.8,
                spaceBetween: 84,
                navigation: {
                    nextEl: $('[data-re-slider-news-next]')[0],
                    prevEl: $('[data-re-slider-news-prev]')[0],
                },
                pagination: {
                    el: $('[data-re-slider-news-pagination]')[0],
                    bulletClass: `re-slider-news__pagination-item`,
                    bulletActiveClass: `re-slider-news__pagination-item--active`,
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    520: {
                        slidesPerView: 1.9,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2.4,
                        spaceBetween: 20,
                    },
                    1279: {
                        slidesPerView: 2.8,
                        spaceBetween: 84,
                    }
                },
                on: {
                    init: (swiper) => {
                        setTimeout(() => {
                            sliderReNewsAutoHeight(swiper)
                        },100)
                    },
                    resize: (swiper) => {
                        setTimeout(() => {
                            sliderReNewsAutoHeight(swiper)
                        },100)
                    }
                }
            })
        }
        clearInterval(intervalContactsBlock)
    }
}, 100)
/**/

function sliderReNewsAutoHeight(swiper) {
    const arr = []
    swiper.slides.forEach(item => {
        $(item).css({height: false})
    })
    swiper.slides.forEach(item => {
        const reSliderNewsImgWrap = $(item).find('.re-slider-news__img-wrap').height()
        const reSliderNewsContent = $(item).find('.re-slider-news__content').outerHeight()
        const reSliderNewsItemFooter = $(item).find('.re-slider-news__item-footer').height()
        const reSliderNewsItemFooterBottom = Number(parseInt($(item).find('.re-slider-news__item-footer').css('bottom')))
        $(item).css({height: `${reSliderNewsImgWrap + reSliderNewsContent + reSliderNewsItemFooter + reSliderNewsItemFooterBottom}px`})
        arr.push(reSliderNewsImgWrap + reSliderNewsContent + reSliderNewsItemFooter + reSliderNewsItemFooterBottom)
        console.log(reSliderNewsImgWrap, reSliderNewsContent, reSliderNewsItemFooter, reSliderNewsItemFooterBottom)
    })
    swiper.slides.forEach(item => {
        $(item).css({height: `${Math.max.apply(null, arr)}px`})
    })
    swiper.update()
}


$(window).on('DOMContentLoaded', function () {
    let count = 0;

    if($('[data-no-copy]').length > 0){
        $(document).bind('keydown keypress', 'ctrl+s', function(){
            $('#save').click();
            return false;
        });
        $("html").on("contextmenu",function(e){
            return false;
        });
        $('html').bind('cut copy paste', function (e) {
            e.preventDefault();
        });
        document.onselectstart=new Function ("return false");
        if (window.sidebar){
            document.onmousedown=killCopy;
            document.onclick=reEnable;
        }
    }

    function killCopy(e){ return false }
    function reEnable(){ return true }

    const interval = setInterval(() => {
        count = count + 100
        if ($('.plyr').length > 0) {
            videoFullScreen()
            clearInterval(interval)
        }
        if (count === 10000) {
            clearInterval(interval)
        }
    }, 100)

    if($('[data-select-news-item]').length > 0){
        $('[data-select-news-item]').each(function (){
            if($(this).hasClass('active')){
                $('[data-select-custom-reset]').removeClass('hidden')
                $(this).parents('.select-custom').find('[data-select-custom-title]').text($(this).text())
            }
            $(this).on('click', function (){
                const attr = $(this).attr('data-select-news-item')
                if(attr){
                    window.location.href = attr
                }
            })
        })
    }

    if($('[data-select-custom-year-default]').length > 0){
        let isDefaultTitle = true
        $('[data-select-custom-year-default]').parents('.select-custom').find('[data-select-news-item]').each(function (){
            if($(this).hasClass('active')){
                isDefaultTitle = false
            }
        })
        if(isDefaultTitle){
            $('[data-select-custom-year-default]').text('Все года')
        }
    }

    if($('[data-select-custom-type-default]').length > 0){
        let isDefaultTitle = true
        $('[data-select-custom-type-default]').parents('.select-custom').find('[data-select-news-item]').each(function (){
            if($(this).hasClass('active')){
                isDefaultTitle = false
            }
        })
        if(isDefaultTitle){
            $('[data-select-custom-type-default]').text('Все темы')
        }
    }

    if ($('.partnership__item').length > 0) {
        partnershipItemResize()
        $(window).resize(() => {
            partnershipItemResize()
        })
    }

    function partnershipItemResize() {
        let partnershipItemTitle = []
        let partnershipItemText = []
        $('.partnership__item-title').each(function () {
            $(this).removeAttr('style')
        })
        $('.partnership__item-text').each(function () {
            $(this).removeAttr('style')
        })
        if ($(window).width() > 960) {
            $('.partnership__item').each(function () {
                partnershipItemTitle.push($(this).find('.partnership__item-title').height())
                partnershipItemText.push($(this).find('.partnership__item-text').height())
            })
            $('.partnership__item-title').each(function () {
                $(this).css('minHeight', `${Math.max.apply(null, partnershipItemTitle)}px`)
            })
            $('.partnership__item-text').each(function () {
                $(this).css('minHeight', `${Math.max.apply(null, partnershipItemText)}px`)
            })
        }
    }

    function videoFullScreen() {
        $('.plyr').each(function () {
            $(this).find('.plyr__control.plyr__control--overlaid').on('click', function () {
                if (window.screen.width < 960) {
                    $('[data-plyr="fullscreen"]').trigger('click')
                }
            })
        })
    }

    /*new contact*/

    if ($('[data-contacts-block-tabs-swiper]').length) {
        dataContactsBlockTabsSwiper.init();
    }

    /*new contact*/

    if (document.querySelectorAll(selectorSlider.bannerMultiple)[0]) {
        multipleBannerSwiper.init();
    }

    if (document.querySelectorAll(selectorSlider.reBannerMultiple)[0]) {
        multipleReBannerSwiper.init();
    }

    if ($('.banner-main--ginekology').length > 0) {
        $('.reg-btn').addClass('hidden')
        $(window).scroll(function () {
            if (($(window).scrollTop() + $(window).height()) > $(document).height() / 2) {
                if ($('.reg-btn').hasClass('hidden')) {
                    $('.reg-btn').removeClass('hidden')
                }
            } else {
                if (!$('.reg-btn').hasClass('hidden')) {
                    $('.reg-btn').addClass('hidden')
                }
            }
        })
    }

    if ($('.tabs--ginekologika').find('.js-video-wrap').length > 0 && $(window).width() > 1025) {
        const mTopDesktop = 123;
        $('.tabs--ginekologika').find('.js-video-wrap').each(function () {
            if ($(this).height() > ($(window).height() - mTopDesktop)) {
                $(this).parent().css('paddingBottom', `${(($(window).height() - mTopDesktop - 30) / $(this).width()) * 100}%`)
                $(this).parent().css('backgroundSize', '100%')
                $(this).parent().css('backgroundPosition', 'center')
            }
        })
    }

    if (document.querySelectorAll(selectorSlider.news)[0]) {
        setTimeout(function () {
            if (sliderNews) {
                sliderNews.init();
            }
        }, 500);
    }

    if (document.querySelectorAll(selectorSlider.reNews)[0]) {
        setTimeout(function () {
            if (sliderReNews) {
                sliderReNews.init();
            }
        }, 500);
    }

    if (document.querySelector(selectorSlider.sliderSteps) && document.querySelector(selectorSlider.sliderStepsThumb)) {
        if (window.innerWidth < 1280) {
            sliderSteps.init();
            sliderStepsThumb.init();
        }

        window.addEventListener('resize', function () {
            if (window.innerWidth < 1280) {
                if(sliderSteps.swiper === null && sliderStepsThumb.swiper === null){
                    sliderSteps.init();
                    sliderStepsThumb.init();
                }
            } else {
                sliderSteps.destroy();
                sliderStepsThumb.destroy();
            }
        })
    }

    if (document.querySelectorAll(selectorSlider.reSlider)[0]) {
        if (reSlider) {
            reSlider.init();
        }
    }

    const cardioSliders = document.querySelectorAll(selectorSlider.reSliderCardio);
    cardioSliders.forEach(function (sliderContainer) {
        const tag = reSliderCardioTagSwapper(sliderContainer);
        reSliderCardio.init(tag);
    });

    if (document.querySelectorAll("[id^='story-profile-']")[0] && reSliderStories) {
        const stories = document.querySelectorAll("[id^='story-profile-']");
        const storiesInner = document.querySelectorAll("[id^='story-inner-']");
        const storiesModal = [];

        storiesInner.forEach((storyModal) => {
            let modalBuffer = GLightbox({
                elements: [
                    {
                        'content': storyModal
                    },
                ],
                width: '100vw',
                height: '100vh',
                touchNavigation: false,
                touchFollowAxis: false,
                keyboardNavigation: false,
                closeOnOutsideClick: false,
                draggable: false,
            });

            modalBuffer.on('open', () => {
                if (document.querySelectorAll(selectorSlider.reSliderStories)[0]) {
                    reSliderStories.init();
                }
            });

            modalBuffer.on('close', () => {
                reSliderStories.destroy();
            });

            storiesModal.push(modalBuffer);
        });

        stories.forEach((story, index) => {
            story.addEventListener("click", () => {
                storiesModal[index].open();
            });
        });

        document.getElementById("slide-container").remove();
    }

    if (document.querySelectorAll(selectorSlider.reSliderPopular)[0]) {
        if (reSliderPopular) {
            reSliderPopular.init();
        }
    }

    if (document.querySelectorAll(selectorSlider.reSliderMobile)[0]) {
        if (reSliderMobile) {
            reSliderMobile.init();

            const clicker = document.querySelectorAll(`${selectorSlider.reSliderMobile} [data-re-facoties-clicker]`);
            clicker.forEach(slide =>
                slide.addEventListener('click', () => {
                    if (App.W.outerWidth() > 767) {
                        clicker.forEach(slideInner => {
                            slideInner.classList.toggle('active');
                        })
                    }
                })
            );
        }
    }

    if (document.querySelectorAll(selectorSlider.bannerSingle)[0]) {
        detectBlockOnScreen();
    }

    if (document.querySelectorAll(selectorSlider.products)[0]) {
        sliderProducts.init();
    }

    window.sendYm = [];
    let countBlockAppearance = 0;
    let blockAppearanceIntervalTime = 100;
    const blockAppearanceInterval = setInterval(() => {
        countBlockAppearance = countBlockAppearance + blockAppearanceIntervalTime
        if ($('video[ym-send-event]').length > 0) {
            initYmSendEvent()
            clearInterval(blockAppearanceInterval)
        }
        if (countBlockAppearance > 10000) {
            clearInterval(blockAppearanceInterval)
        }
    }, blockAppearanceIntervalTime)

    function initYmSendEvent() {
        $('video[ym-send-event]').each(function () {
            $(this).on('play', function () {
                let val = $(this).attr('ym-send-event');
                let params = $(this).attr('ym-send-params');
                if (val && !window.sendYm[val] && window.ym) {
                    window.ym(1128028, 'reachGoal', val, params ? params : {});
                    window.sendYm[val] = true;
                }
            })
        })
    }

    const supportInput = document.querySelectorAll('.support__input');

    supportInput.forEach(input => {
        const parent = input.closest('.support__field');
        const label = parent.querySelector('.support__label');

        if (input.value.length) {
            label.classList.add('support__label--focused');
        }

        input.addEventListener('focus', () => {
            label.classList.add('support__label--focused');
        });

        input.addEventListener('blur', () => {
            if (input.value.length) {
                return
            }

            label.classList.remove('support__label--focused');
        });
    });

    const dropZones = document.querySelectorAll('.dropzone');
    let isDropSubmit = false;

    if (dropZones && dropZones.length > 0) {
        dropZones.forEach(dropzone => {
            const url = dropzone.closest('form').getAttribute('action');
            const myDropzone = new Dropzone(dropzone, {
                url,
                autoProcessQueue: false,
                uploadMultiple: true,
                parallelUploads: 100,
                maxFiles: 100,
                previewsContainer: '.dropzone-previews',
                previewTemplate: '<div class="dz-preview dz-file-preview">' +
                    '<div class="dropzone__subtitle"></div>' +
                    '<div class="dz-details">' +
                    '<img class="dz-thumb" data-dz-thumbnail />' +
                    '<div class="dz-name-row"><div class="dz-filename" data-dz-name></div>' +
                    '<div class="dz-size"><span class="dz-type"></span> <span data-dz-size></span></div></div>' +
                    '<a class="dz-remove" href="javascript:undefined;" data-dz-remove></a>' +
                    '</div>' +
                    '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
                    '</div>',
                init: function () {
                    var myDropzone = this;
                    const formSupport = this.element;
                    const fields = formSupport.querySelectorAll("input");

                    fields.forEach(function (value, key) {
                        value.addEventListener('change', function () {
                            const agreeFields = formSupport.querySelectorAll("input[data-with_agree]");
                            let isRequiredAgree = false;

                            agreeFields.forEach(function (value, key) {
                                isRequiredAgree = isRequiredAgree || ($(value).val().length > 0)
                            });

                            if (isRequiredAgree) {
                                $('#formagree').attr('data-required', 'Y');
                                $('[data-name="checkboxAgreeBlock"]').removeAttr('style');
                            } else {
                                $('#formagree').removeAttr('data-required');
                                $('#formagree').removeClass('_error');
                                $('[data-name="checkboxAgreeBlock"]').attr('style', 'display: none;');
                            }
                        });
                    });

                    formSupport.addEventListener("submit", function (e) {
                        // Make sure that the form isn't actually being sent.
                        e.preventDefault();
                        e.stopPropagation();

                        if (!formSupport.validateObj.validateAllFields()) {
                            return;
                        }

                        myDropzone.processQueue();
                    });

                    this.on("sending", function () {
                        isDropSubmit = true;
                        formSupport.querySelector("button[type=submit]").setAttribute('disabled', 'disabled');
                    });
                    this.on("success", function (file, response) {
                        formSupport.closest('.js-common-popup').querySelector('.js-common-popup-close').click();
                        formSupport.querySelector("button[type=submit]").removeAttribute('disabled');
                        myDropzone.removeAllFiles();
                        isDropSubmit = false;
                        if (response.success) {
                            $('[data-name="modalSupportThank"]').addClass('common-popup--opened');
                        } else {
                            $('[data-name="modalSupportErrorText"]').text(response.message);
                            $('[data-name="modalSupportError"]').addClass('common-popup--opened');
                        }
                    });
                    this.on("error", function (file, response) {
                        formSupport.closest('.js-common-popup').querySelector('.js-common-popup-close').click();
                        formSupport.querySelector("button[type=submit]").removeAttribute('disabled');
                        myDropzone.removeAllFiles();
                        isDropSubmit = false;
                        $('[data-name="modalSupportError"]').addClass('common-popup--opened');
                    });
                }
            });

            myDropzone.on("addedfile", file => {
                const dropzoneEl = myDropzone.element;
                const block = file.previewTemplate;
                const subtitle = block.querySelector('.dropzone__subtitle');
                const thumb = block.querySelector('.dz-thumb');
                const btn = dropzoneEl.querySelector('.dz-button');
                const type = block.querySelector('.dz-type');
                const name = block.querySelector('.dz-filename');
                dropzoneEl.querySelector('.dropzone__init').classList.add('dropzone__init--hidden');
                btn.innerText = 'Прикрепить другой';
                type.innerText = file.name.slice(file.name.lastIndexOf('.') + 1) + ', ';
                name.innerText = file.name.replace(file.name.slice(file.name.lastIndexOf('.')), '');
                const fileType = file.type.includes('image/') ? 'image' : 'document';
                subtitle.innerText = fileType === 'image' ? 'Изображение прикреплено' : 'Документ прикреплен';
                if (fileType !== 'image') {
                    thumb.setAttribute('src', '/img/svg/file.svg');
                    thumb.classList.add('dz-thumb--icon');
                }
            });

            myDropzone.on('removedfile', file => {
                if (!myDropzone.files.length) {
                    const dropzoneEl = myDropzone.element;
                    dropzoneEl.querySelector('.dropzone__init').classList.remove('dropzone__init--hidden');
                    const btn = dropzoneEl.querySelector('.dz-button');
                    btn.innerText = 'Прикрепить';
                }
            });
        });
    }

    const formSupport = document.querySelector('.js-support-form');

    if (formSupport !== null && formSupport.length) {
        formSupport.validateObj = new Validate(formSupport);
        formSupport.addEventListener('submit', e => {
            if (!formSupport.validateObj.validateAllFields()) {
                return;
            }

            e.preventDefault();

            if (isDropSubmit) {
                return
            }

            formSupport.querySelector("button[type=submit]").setAttribute('disabled', '');
            const dataForm = $(formSupport).serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});

            $.ajax({
                url: formSupport.action,
                dataType: 'json',
                data: dataForm,
                type: formSupport.method,
                success: function (response) {
                    if (response.success) {
                        $('[data-name="modalSupportThank"]').addClass('common-popup--opened');
                    } else {
                        $('[data-name="modalSupportErrorText"]').text(response.message);
                        $('[data-name="modalSupportError"]').addClass('common-popup--opened');
                    }
                },
                error: function (err) {
                    $('[data-name="modalSupportError"]').addClass('common-popup--opened');
                },
                beforeSend: function () {
                    formSupport.querySelector("button[type=submit]").removeAttribute('disabled');
                    formSupport.closest('.js-common-popup').querySelector('.js-common-popup-close').click();
                }
            });
        })
    }
});

let offsetScrollTop = {}
let menuBlockStickyInterval = null;
let menuBlockStickyCount = 0;
let menuSwiper = null;
let indexMenuBlockSticky = {}
let isAddClass = true;
/*About*/
let slideChangeCount = 0;
let slideChangeArr = {};
let breadcrumbsSlider = null;
let breadcrumbsSliderWidth = 0;
document.addEventListener('DOMContentLoaded', () => {
    breadcrumbsSliderWidth = $('.js-breadcrumbs ul').outerWidth()

    if($('[data-articles-block-section-href]').length){
        $('[data-articles-block-section-href]').on('click', function () {
            const active =$('[data-articles-block-section-block]').hasClass('active')
            if(active){
                $('[data-articles-block-section-block]').removeClass('active')
            }else{
                $('[data-articles-block-section-block]').addClass('active')
            }
        })
    }

    if($('[data-stories-wrapper]').length){
        const hash = window.top.location.hash.substring(1);
        if(hash && hash.replace(/[0-9]/g, '') === 'stories'){
            const item = hash.match(/\d+/)
            const count = item ? parseInt(item[0], 10) : null;
            setTimeout(()=>{
                const scrollTop = $('[data-stories-wrapper]').offset().top
                $('html, body').stop().animate({
                    'scrollTop': scrollTop
                }, 900, 'swing', function () {
                    if(count !== null){
                        $('[data-stories-swiper]')[0].swiper.slideTo(count)
                        $(`[data-stories-item="${count}"]`).find('.page-cardio-tuesday__story_profile-item').trigger('click')
                    }
                })
            }, 200)
        }
    }

    if ($('[data-text-block-info-content]').length > 0) {
        $('[data-text-block-info-content]').find('p[style="text-align: right;"]').each(function (e) {
            if ($(this).text().trim() && $(this).find('i').length === 0) {
                if (e === 0) {
                    $(this).text($(this).text().replace(',', ''))
                }
                if ($(this).find('b').length > 0) {
                    $(this).find('b').each(function () {
                        $(this).parents('.text-block--person').find('[data-text-block-info-top-content]').append(`<p>${$(this).text()}</p>`)
                    })
                    $(this).remove()
                } else {
                    $(this).parents('.text-block--person').find('[data-text-block-info-top-content]').append($(this))
                }
            }
        })
    }

    Object.values($('[data-re-slider-news-detail-wrapper]').children()).forEach(el => {
        if (el.localName === "br") {
            $(el).remove()
        }
    })

    if ($('[data-clamp-text]').length > 0) {
        resourceLoader('/js/jquery.clamp.min.js', () => {
            $('[data-clamp-text]').each(function () {
                const attr = $(this).attr('data-clamp-text')
                if (attr) {
                    $(this).clamp({
                        clamp: Number(attr),
                    })
                }
            })
        })
    }

    if ($('[data-partnership-card]').length > 0) {
        $('[data-partnership-card]').each(function () {
            $(this).on('click', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active')
                } else {
                    $(this).addClass('active')
                }
            })
        })

        setPartnershipCardTransform()
        $(window).resize(function () {
            setPartnershipCardTransform()
        })
    }

    if ($('[data-partnership-accordion-item]').length > 0) {
        $('[data-partnership-accordion-item]').each(function () {
            $(this).on('click', function () {
                if ($($(this).parent()).hasClass('active')) {
                    $($(this).parent()).removeClass('active')
                } else {
                    $($(this).parent()).addClass('active')
                }
            })
        })
    }
    breadcrumbsSliderPoints()
    //initBreadcrumbsSlider()
    $('.re-about__link').each(function () {
        $(this).on('click', function (e) {
            e.preventDefault()
            $(this).parent('.re-about__item-wrap').find('[data-re-about]').trigger('click')
        })
    })
    $('[data-re-about]').each(function () {
        $(this).on('click', function () {
            const scrollTop = $($('[data-re-about-content]')[$(this).attr('data-re-about')]).offset().top - 48
            $('html, body').stop().animate({
                'scrollTop': scrollTop
            }, 900, 'swing')
        })
    })

    $('.select-custom').each(function (){
        $(this).find('[data-select-custom-title]').on('click', function (e){
            e.stopPropagation()
            $(this).parents('.select-custom').find('[data-select-custom-list]').toggle()
            if($(this).parents('.select-custom').find('[data-select-custom-list]').css('display') === 'block'){
                $(this).addClass('active')
            } else {
                $(this).removeClass('active')
            }
        })
    })

    if($('[data-company-history-bottom-item]').length > 0){
        $('[data-company-history-bottom-item]').each(function (i){
            if($('[data-company-history-bottom-end]').text().trim() === $(this).text().trim()){
                $('[data-company-history-bottom-end]').on('click', function (){
                    companyHistorySwiperOne.slideTo(i)
                })
            }
            $(this).on('click', function (){
                companyHistorySwiperOne.slideTo(i)
            })
        })
    }

    $('[data-select-custom-item]').each(function (i){
        $(this).on('click', function (e){
            e.stopPropagation()
            $('[data-select-custom-title]').text($(this).attr('data-select-custom-item')).addClass('active')
            companyHistorySwiperOne.slideTo(i)
            $('[data-select-custom-item]').each(function (){
                $(this).removeClass('active')
            })
            $(this).addClass('active')
            $('[data-select-custom-list]').css('display', 'none')
            $('[data-select-custom-title]').removeClass('active')
        })
    })

    $('body').on('click', function () {
        $('[data-select-custom-list]').css('display', 'none')
        $('[data-select-custom-title]').removeClass('active')
    })

    $('[data-about-chart-left]').each(function () {
        $(this).on('mouseover', function () {
            $('[data-about-chart-left]').each(function () {
                $(this).addClass('active')
            })
            $('[data-about-chart-left-new]').addClass('active')
        })
        $(this).on('mouseout', function () {
            $('[data-about-chart-left]').each(function () {
                $(this).removeClass('active')
            })
            $('[data-about-chart-left-new]').removeClass('active')
        })
    })
    $('[data-about-chart-right]').each(function () {
        $(this).on('mouseover', function () {
            $('[data-about-chart-right]').each(function () {
                $(this).addClass('active')
            })
            $('[data-about-chart-right-new]').addClass('active')
        })
        $(this).on('mouseout', function () {
            $('[data-about-chart-right]').each(function () {
                $(this).removeClass('active')
            })
            $('[data-about-chart-right-new]').removeClass('active')
        })
    })


    $('[data-about-info-block-item]').each(function (e) {
        if ($(window).width() < 767) {
            $(this).removeClass('active')
        }
        $(this).on('click', function () {
            if ($(window).width() < 767) {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active')
                } else {
                    $(this).addClass('active')
                }
            } else {
                $('[data-about-info-block-item]').each(function () {
                    $(this).removeClass('active')
                })
                $(this).addClass('active')
                $('[data-about-info-block-right]').attr('data-about-info-block-right', e)
            }
        })
    })

    $('[data-about-info-block-item-svg]').each(function (e) {
        $(this).on('click', function () {
            $('[data-about-info-block-item]').each(function () {
                $(this).removeClass('active')
            })
            $($('[data-about-info-block-item]')[e]).addClass('active')
            $('[data-about-info-block-right]').attr('data-about-info-block-right', e)
        })
    })


    $('[data-about-video-play]').on('click', function () {
        $('[data-about-video-content]').addClass('active')
        playVideo()
    })


    $(window).on('resize', () => {
        getHeaderResize()
        breadcrumbsSliderPoints()
        //initBreadcrumbsSlider()
    })

    setTimeout(() => {
        getHeaderResize()
        if (window.location.pathname.includes('doctor')) {
            setTopMenu()
            $(window).scroll(function () {
                setTopMenu()
            })
        }
    }, 500)

    if ($('[data-menu-block-sticky-row]').length > 0) {
        $('[data-menu-block-sticky-item]').each(function () {
            const attr = $(this).attr('data-menu-block-sticky-item')
            $('[data-menu-block-sticky-wrapper]').append(`<div class="menu-block-sticky__swiper-slide swiper-slide" data-menu-block-sticky-slide="${attr}">${attr}</div>`)
        })
        menuBlockStickyInterval = setInterval(() => {
            menuBlockStickyCount = menuBlockStickyCount + 100
            if (window.Swiper) {
                menuSwiper = new Swiper($('[data-menu-block-sticky]')[0], {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    breakpoints: {
                        0: {
                            spaceBetween: 8,
                        },
                        767: {
                            spaceBetween: 10,
                        }
                    },
                    on: {
                        init: (swiper) => {
                            if ($(window).width() < 760) {
                                swiper.slides.forEach((el, i) => {
                                    indexMenuBlockSticky[i] = el.getBoundingClientRect().left - 16
                                })
                            }
                        }
                    }
                })
                clearInterval(menuBlockStickyInterval)
            }
            if (menuBlockStickyCount === 10000) {
                clearInterval(menuBlockStickyInterval)
            }
        }, 100)

        const mutationMenuBlockStickyObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if ($(mutation.target).hasClass('_hide-top')) {
                    $('[data-menu-block-sticky-row]').addClass('up')
                } else {
                    $('[data-menu-block-sticky-row]').removeClass('up')
                }
            });
        });

        mutationMenuBlockStickyObserver.observe($('.header.js-scroll-header')[0], {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });

        setTimeout(() => {
            if ($('.header .js-scroll-header').hasClass('_hide-top')) {
                scrollBlockEvent(0)
            } else {
                scrollBlockEvent(1)
            }
        }, 500)

        let lastScrollTop = 0;

        $(document).on('scroll', () => {
            const st = $(window).scrollTop()
            if (st > lastScrollTop) {
                scrollBlockEvent(0)
            } else if (st < lastScrollTop) {
                scrollBlockEvent(1)
            }
            lastScrollTop = st <= 0 ? 0 : st;
            if (st <= 0) {
                $('[data-menu-block-sticky-row]').removeClass('show')
            } else {
                $('[data-menu-block-sticky-row]').addClass('show')
            }
        })

        const anchor = window.top.location.hash.substring(1)
        if (anchor !== '') {
            setTimeout(() => {
                $($('[data-menu-block-sticky-slide]')[anchor]).trigger('click')
            }, 600)
        }

        $('[data-menu-block-sticky-slide]').on('click', function () {
            const attr = $(this).text()
            $('[data-menu-block-sticky-slide]').each(function () {
                $(this).removeClass('active')
            })
            $(this).addClass('active')
            if ($(window).width() < 767 && menuSwiper) {
                $(menuSwiper.$wrapperEl[0]).css({
                    "-webkit-transform": `translate(-${Math.abs(indexMenuBlockSticky[menuSwiper.slides.findIndex(el => $(el).hasClass('active'))])}px,0)`,
                    'transition': '0.6s'
                })
            }
            let scrollTop = 0;
            if ($('[data-menu-block-sticky-row]').offset().top > $(`[data-menu-block-sticky-item ="${attr}"]`).offset().top) {
                scrollTop = $(`[data-menu-block-sticky-item="${attr}"]`).offset().top - offsetScrollTop[0]
            } else {
                scrollTop = $(`[data-menu-block-sticky-item="${attr}"]`).offset().top - offsetScrollTop[1]
            }
            isAddClass = false
            $('html, body').stop().animate({
                'scrollTop': scrollTop
            }, 900, 'swing', function () {
                setTimeout(() => {
                    isAddClass = true
                }, 100)
            });
        })
    }

    if (document.querySelector('.js-materials-files')) {
        const dropdownButton = document.getElementById('materialsDropdownButton');
        const dropdownMenu = document.getElementById('dropdownMenu');
        const placeholder = document.getElementById('materialsDropdownPlaceholder');

        dropdownButton.addEventListener('click', () => {
            dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
            dropdownButton.classList.toggle('active');
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.materials-form-dropdown')) {
                dropdownMenu.style.display = 'none';
                dropdownButton.classList.remove('active');
            }
        });

        dropdownMenu.addEventListener('click', (e) => {
            if (e.target.tagName === 'LI') {
                const specialtyId = e.target.dataset.id;

                fetch('/bitrix/services/main/ajax.php?mode=class&c=cpeople:materials&action=getMaterials', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({specialtyId: specialtyId})
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data && data.status === 'success') {
                            const container = document.querySelector('.js-materials-files');
                            container.innerHTML = data.data.data.html;
                        }
                    })
                    .catch(error => {
                        console.error('Ошибка AJAX:', error);
                    });

                placeholder.textContent = e.target.textContent;
                dropdownMenu.style.display = 'none';
                dropdownButton.classList.remove('active');
            }
        });
    }
});

function getHeaderResize() {
    let headerTop
    if ($('.js-scroll-header').hasClass('_hide-top')) {
        headerTop = Number($('.header-top').css('marginTop').match(/\d+/g)[0])
    } else {
        headerTop = $('.header-top').height()
    }
    const headerNav = $('.header-nav.js-header-nav').height()
    const breadcrumbs = $('.breadcrumbs.js-breadcrumbs').outerHeight()
    const mobileMenuTop = $('.mobile-menu__top').height()
    const mobileMenuBottom = $('.mobile-menu__bottom.mobile-menu-bottom-js').height()
    let menuBlockStickyRow = 0;
    if ($('[data-menu-block-sticky-row]').length > 0) {
        menuBlockStickyRow = $('[data-menu-block-sticky-row]').outerHeight()
    }
    if ($(window).width() >= 1023) {
        offsetScrollTop[0] = headerTop + headerNav + breadcrumbs + menuBlockStickyRow
        offsetScrollTop[1] = headerTop + headerNav + menuBlockStickyRow
    } else if ($(window).width() < 1023 && $(window).width() >= 767) {
        offsetScrollTop[0] = mobileMenuTop + mobileMenuBottom + breadcrumbs + menuBlockStickyRow
        offsetScrollTop[1] = mobileMenuTop + mobileMenuBottom + menuBlockStickyRow
    } else {
        offsetScrollTop[0] = mobileMenuTop + breadcrumbs + menuBlockStickyRow
        offsetScrollTop[1] = mobileMenuTop + menuBlockStickyRow
    }
}

let breadcrumbsSliderInterval = null;
let textBreadcrumbs = ''
let isTextBreadcrumbs = true;
let countBreadcrumbs = 0;

function breadcrumbsSliderPoints(){
    const breadcrumbsLength = $('.js-breadcrumbs ul li').length
    const el = $($('.js-breadcrumbs ul li')[breadcrumbsLength - 1])
    setTimeout(()=>{
        if(textBreadcrumbs){
            el.html(textBreadcrumbs)
        }
        if(isTextBreadcrumbs){
            textBreadcrumbs = el.html()
            countBreadcrumbs = el.find('span').outerWidth( true )/el.find('span').text().length
            isTextBreadcrumbs = false
        }
        if ($('.js-breadcrumbs ul').offset() && ($('.js-breadcrumbs ul').width() + $('.js-breadcrumbs ul').offset().left) >= $(window).width()) {
            const widthEl = $(window).width() - el.offset().left - 80
            if(widthEl > 200){
                el.html(truncateString(textBreadcrumbs, widthEl/countBreadcrumbs))
                destroyBreadcrumbs()
            } else {
                initBreadcrumbs()
            }
        } else {
            el.html(textBreadcrumbs)
            destroyBreadcrumbs()
        }
    }, 700)
}

function truncateString(s, w){
    return s.length > w ? s.slice(0, w).trim() + "..." : s
}

function initBreadcrumbs(){
    if (breadcrumbsSlider === null) {
        if (!$('.js-breadcrumbs').hasClass('swiper')) {
            $('.js-breadcrumbs').addClass('swiper')
            $('.js-breadcrumbs ul').addClass('swiper-wrapper')
            $('.js-breadcrumbs ul li').each(function () {
                $(this).addClass('swiper-slide')
            })
        }
        if (window.Swiper) {
            breadcrumbsSlider = new window.Swiper($('.js-breadcrumbs')[0], {
                slidesPerView: 'auto',
                spaceBetween: 10,
            })
        } else {
            breadcrumbsSliderInterval = setInterval(() => {
                if (window.Swiper) {
                    clearInterval(breadcrumbsSliderInterval)
                    breadcrumbsSlider = new window.Swiper($('.js-breadcrumbs')[0], {
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                    })
                }
            }, 100)
        }
    }
}
function destroyBreadcrumbs(){
    if (breadcrumbsSlider !== null) {
        if ($('.js-breadcrumbs').hasClass('swiper')) {
            $('.js-breadcrumbs').removeClass('swiper')
            $('.js-breadcrumbs ul').removeClass('swiper-wrapper')
            $('.js-breadcrumbs ul li').each(function () {
                $(this).removeClass('swiper-slide')
            })
        }
        breadcrumbsSlider.destroy(true, true)
        breadcrumbsSlider = null;
    }
}

async function playVideo() {
    try {
        await $('[data-about-video]')[0].play();
        $('[data-about-video]').on('click', function () {
            if ($(this)[0].paused) {
                $('[data-about-video]')[0].play();
            } else {
                $('[data-about-video]')[0].pause();
            }
        })
    } catch (err) {
        console.log(err)
    }
}

function setTopMenu() {
    $('.js-anchor-menu').each(function () {
        if ($('.header').hasClass('_hide-top')) {
            $(this).css('top', `${offsetScrollTop[1]}px`)
        } else {
            $(this).css('top', `${offsetScrollTop[0] - 5}px`)
        }

    })
}

function addText(count) {
    if ($(window).width() < 1270) {
        const text = $($('[data-company-history-row]')[count]).find('.company-history-block__text').text()
        $('[data-company-history-text]').text(text)
    } else {
        $('[data-company-history-text]').text('')
    }
}

function setPartnershipCardTransform() {
    if ($(window).width() < 960) {
        if ($('[data-partnership-card-left]').length === 0) {
            $('[data-partnership-card-row]').append('<div class="partnership__cards-row-left" data-partnership-card-left></div><div class="partnership__cards-row-right" data-partnership-card-right></div>')
            $('[data-partnership-card]').each(function (e) {
                const attr = Number($(this).attr('data-partnership-card'))
                if (attr % 2 == 0) {
                    $('[data-partnership-card-right]').append($(this))
                } else {
                    $('[data-partnership-card-left]').append($(this))
                }
            })
        }
    } else {
        if ($('[data-partnership-card-left]').length > 0) {
            $('[data-partnership-card]').each(function (e) {
                $('[data-partnership-card-row]').append($(`[data-partnership-card=${e + 1}]`))
            })
            $('[data-partnership-card-left]').remove()
            $('[data-partnership-card-right]').remove()
        }
    }
}


function resourceLoader(url, callback) {
    $.ajax(url)
        .then((res) => {
            if (res) {
                const element = document.createElement('script');
                element.innerHTML = res;
                document.head.appendChild(element);
                callback()
            }
        })
}


function scrollBlockEvent(count) {
    let obg = {}
    $('[data-menu-block-sticky-item]').each(function (e) {
        const attr = $(this).attr('data-menu-block-sticky-item')
        const scrollTop = $(window).scrollTop()
        if (scrollTop > ($(this).offset().top - offsetScrollTop[count]) && (($(this).offset().top + $(this).height()) - offsetScrollTop[count]) > scrollTop) {
            obg[e] = true
            if (isAddClass) {
                $(`[data-menu-block-sticky-slide]`).each(function () {
                    $(this).removeClass('active')
                })
                $(`[data-menu-block-sticky-slide="${attr}"]`).addClass('active')

                if ($('[data-about-video-content]').length) {
                    if (attr.toLowerCase() === 'о нас') {
                        $('[data-about-video-play]').trigger('click')
                    } else {
                        $('[data-about-video]')[0].pause();
                    }
                }

                if ($(window).width() < 767 && menuSwiper) {
                    $(menuSwiper.$wrapperEl[0]).css({
                        "-webkit-transform": `translate(-${Math.abs(indexMenuBlockSticky[menuSwiper.slides.findIndex(el => $(el).hasClass('active'))])}px,0)`,
                        'transition': '0.6s'
                    })
                }
            }
        } else {
            obg[e] = false
        }
    })
    if (!Object.values(obg).find(item => item === true)) {
        if (isAddClass) {
            $(`[data-menu-block-sticky-slide]`).each(function () {
                $(this).removeClass('active')
            })
            if ($('[data-about-video-content]').length) {
                $('[data-about-video]')[0].pause();
            }
            if ($(window).width() < 767 && menuSwiper) {
                $(menuSwiper.$wrapperEl[0]).css({"-webkit-transform": `translate(0,0)`, 'transition': '0.6s'})
            }
        }
    }

}
